import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import { AppProvider } from './utils/Context.tsx'
import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://7abf4647a3561bd87f1d7c7623c78cc3@o4508931235381248.ingest.de.sentry.io/4508931343777872',
})
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </StrictMode>
)
